import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import AdminInboundEmailPage from "@/pages/admin/AdminInboundEmailPage";

export const Route = createFileRoute("/_admin/admin/inbound-email")({
  head: () => pageHead("Admin · Inbound Email", "AKIVA admin · inbound email portal.", "/admin/inbound-email", true),
  component: AdminInboundEmailPage,
});
